import React from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Image, Space, Typography, Button, Grid } from 'antd';
import ImageBanner from '../../assets/img/banner.png';

const { useBreakpoint } = Grid;
const { Text } = Typography;

function Banner({ content }) {
  const {
    titleTop = 'WCHSS',
    subtitleLine1 = 'The 2nd World Conference on Health and',
    subtitleLine2 = 'Social Sciences',
    tagline = '“Connecting People in Health and Social Sciences”',
    dateAndTime = 'October 23 – 24, 2024',
    location = 'Binawan University, Jakarta,  Indonesia',
    ctaLabel = 'Submit Now',
    ctaTo = '/registration',
  } = content || {};

  let { xs, xxl } = useBreakpoint()
  return (
    <React.Fragment>
      <Row style={{ padding: 0, position: 'relative', backgroundColor: '#fff' }}>
        <Col span={24}>
          <Space direction="vertical" size={16} style={xxl ? { zIndex: 1, paddingLeft: 300, paddingTop: 130, marginBottom: -100, position: 'absolute' } : xs ? { zIndex: 1, paddingLeft: 16, paddingTop: 150, marginBottom: -100, position: 'absolute' } : { zIndex: 1, paddingLeft: 50, paddingTop: 130, marginBottom: -100, position: 'absolute' }}>
            <Space direction="vertical">
            </Space>
            <Space direction="vertical" size={xs ? -8 : -16}>
              <Text style={{ fontSize: xs ? 30 : 34, fontWeight: 'bold', color: '#fff' }}>{titleTop}</Text>
              <Text style={{ fontSize: xs ? 20 : 26, color: '#fff' }}>{subtitleLine1}</Text>
              <Text style={{ fontSize: xs ? 20 : 26, color: '#fff' }}>{subtitleLine2}</Text>
            </Space>
            <Text style={{ fontSize: xs ? 18 : 24, color: '#fff' }}>{tagline}</Text>
            <Space direction="vertical" size={xs ? -8 : -16}>
              <Text style={{ fontSize: xs ? 18 : 20, color: '#fff' }}>{dateAndTime}</Text>
              <Text style={{ fontSize: xs ? 18 : 20, color: '#fff' }}>{location}</Text>
            </Space>
            <Link to={ctaTo}>
              <Button className="button-submit">{ctaLabel}</Button>
            </Link>
          </Space>
          <Image
            width={'100%'}
            height={ 560 }
            src={ImageBanner}
            preview={false}
            style={{ objectFit: 'cover' }}
          />
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default Banner